<template>
	<!-- CHECK IF COMPONENT IS IN USE -->
	<v-card class="elevation-1" color="white">
		<v-card-title class="blue--text lighten-1">
			<v-icon large color="blue lighten-1" @click="cancelLocumSearch()">mdi-chevron-left</v-icon>Back
			<v-spacer></v-spacer>
		</v-card-title>
		<v-card-text>
			<!--the card -->

			<v-row readonly flat>
				<v-col>
					<v-list-item>
						<v-list-item-avatar size="80">
							<v-img :src="locum.avatar"></v-img>
						</v-list-item-avatar>
					</v-list-item>

					<v-list-item>
						<v-list-item-content align="center" justify="center">
							<v-list-item-title class="title" v-text="locum.first_name + ' ' + locum.last_name"></v-list-item-title>
							<v-list-item-subtitle class="title blue--text lighten-1" color="orange" v-text="locum.profession"></v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>

					<v-list-item>
						<v-list-item-content align="center" justify="center">
							<v-rating v-model="locum.rating" color="primary" background-color="grey lighten-1" readonly></v-rating>
						</v-list-item-content>
					</v-list-item>

					<v-list-item>
						<v-list-item-content>
							Lorem ipsum dolor sit amet, consectetur adipisicing elit. Illum eligendi alias qui delectus error, pariatur, doloremque dicta accusantium accusamus
							sint, laboriosam esse modi mollitia suscipit natus a? Accusamus, amet voluptates.
						</v-list-item-content>
					</v-list-item>

					<v-list-item>
						<v-list-item-content class="pb-0">
							<p>Location:</p>
							<p class="font-weight-bold" v-text="locum.address.region"></p>
						</v-list-item-content>
					</v-list-item>

					<v-list-item>
						<v-list-item-content class="pt-0 pb-0">
							<p>Experience:</p>
							<p class="font-weight-bold" v-text="locum.experience.start_start">2 Years</p>
						</v-list-item-content>
					</v-list-item>

					<v-list-item>
						<v-list-item-content class="pt-0 pb-0">
							<p>Qualified:</p>
							<p class="font-weight-bold" v-text="locum.qualifications.year_qualified">2008</p>
						</v-list-item-content>
					</v-list-item>

					<v-list-item>
						<v-list-item-content class="pt-0 pb-0">
							<p>University/College:</p>
							<p class="font-weight-bold" v-text="locum.qualifications.institution"></p>
						</v-list-item-content>
					</v-list-item>

					<v-list-item>
						<v-list-item-content class="pt-0 pb-0">
							<p>Weekdays:</p>
							<p class="font-weight-bold" v-text="'R' + locum.working_hours.weekdays.rate + '.00 p/h'"></p>
						</v-list-item-content>
					</v-list-item>

					<v-list-item>
						<v-list-item-content class="pt-0 pb-0">
							<p>Saturday:</p>
							<p class="font-weight-bold" v-text="'R' + locum.working_hours.saturday.rate + '.00 p/h'"></p>
						</v-list-item-content>
					</v-list-item>

					<v-list-item>
						<v-list-item-content class="pt-0 pb-0">
							<p>Sunday/Public Holiday:</p>
							<p class="font-weight-bold" v-text="'R' + locum.working_hours.sundays.rate + '.00 p/h'"></p>
						</v-list-item-content>
					</v-list-item>
				</v-col>
			</v-row>

			<!--end card -->
		</v-card-text>

		<v-card-actions>
			<v-spacer />
			<v-btn rounded color="orange" depressed class="white--text" @click="doBookThisLocum()"
				>Book this Locum
				<v-icon right>mdi-arrow-right</v-icon>
			</v-btn>
			<v-spacer />
		</v-card-actions>
	</v-card>
</template>

<script>
import { bus } from '@/main';
import store from '@/store';

//import axios from "axios";
//import moment from "moment";

export default {
	name: 'PracticeLocumProfile',
	components: {},
	data: () => ({
		items: {},
		//
		locums: [
			{
				avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
				name: 'Jane Doe',
				profession: 'Dentist',
				datetime: '9:00AM -> 11:00PM (2 Hours)',
				location: '',
				university: '',
				bio: 'Lorem Ipsum Lorem Ipsum',
				rating: 4.5,
			},
		],

		languages: store.getters.configs.languages,
	}),

	computed: {
		locum() {
			return store.getters.getPracticeViewingLocum;
		},
		getPracticeOffer() {
			return store.getters.getPracticeOffer;
		},
	},

	created() {},
	beforeDestroy() {
		// bus.$off('intent:submit-forms');
	},
	methods: {
		viewLocumProfile() {
			bus.$emit('change-context', 'practice-locum-profile');
		},

		cancelLocumSearch() {
			bus.$emit('change-context', 'practice-locum-search');
		},
		doBookThisLocum() {
			bus.$emit('change-context', 'practice-to-locum-make-booking');
		},
	},
};
</script>
